import React from 'react';
import classNames from 'classnames/bind';
import Button from '../../../../atoms/button';
import styles from '../index.pcss';

interface EventCTAProps {
  eventType: string;
  ctaLabel: string;
  onCTAClick?: () => void;
  shopMoreUrl?: string;
}

const cx = classNames.bind(styles);

const EventCTA = (props: EventCTAProps): JSX.Element => {
  const { eventType = '', ctaLabel = '', onCTAClick, shopMoreUrl = '' } = props;
  let element = null;
  switch (eventType) {
    case 'PRE_SALE':
      element = (
        <Button
          htmlType="button"
          ariaLabel={ctaLabel}
          variant="primary"
          size="xlg"
          fontWeight="bold"
          btnLabel={ctaLabel}
          onClick={onCTAClick}
          fullWidth
        />
      );
      break;
    case 'ACTIVE_SALE':
      element = (
        <a href={shopMoreUrl} className={cx('event-anchor-cta')}>
          <Button
            htmlType="button"
            ariaLabel={ctaLabel}
            variant="primary"
            size="xlg"
            fontWeight="bold"
            btnLabel={ctaLabel}
            fullWidth
          />
        </a>
      );
      break;
    default:
      element = null;
  }
  return <section className={cx('section')}>{element}</section>;
};

export default EventCTA;
